import { MarqCommonEnumsDomainTypeEnum } from '~/swagger/data-contracts';

export enum DomainTypeEnum {
  Marketplace = 'marketplace',
  SocialMedia = 'social_media',
  Website = 'website',
  MarketplaceAndSocialMedia = 'marketplace,social_media',
}

export const DomainTypeLabel: Record<DomainTypeEnum | MarqCommonEnumsDomainTypeEnum, string> = {
  [DomainTypeEnum.Marketplace]: 'Marketplace',
  [DomainTypeEnum.SocialMedia]: 'Social media', // MarqCommonEnumsDomainTypeEnum.SocialMedia와 동일
  [DomainTypeEnum.Website]: 'Website',
  [DomainTypeEnum.MarketplaceAndSocialMedia]: 'Marketplace & Social media',
  [MarqCommonEnumsDomainTypeEnum.Ecommerce]: 'Marketplace',
  [MarqCommonEnumsDomainTypeEnum.StandAlone]: 'Website',
};
